import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

const ProjectHistoryModal = ({ show, onClose, history }) => {
  const similarStyle = {
    display: 'table',
    width: '100%',
    tableLayout: 'fixed',
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Project History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table>
          <thead style={{ ...similarStyle, width: 'calc(100% - 1rem)' }}>
            <th>Date</th>
            <th>Action</th>
            <th>Performed by</th>
          </thead>
          <tbody style={{
            display: 'block',
            overflow: 'auto',
            maxHeight: '60vh',
          }}>
            {history.map((item, index) => (<tr key={index} style={{ ...similarStyle }}>
              <td>{new Date(item.createdAt).toISOString().split('T')[0]}</td>
              <td>{item.action}</td>
              <td>{item.user.email}</td>
            </tr>))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProjectHistoryModal;
